import { twMerge } from "tailwind-merge";

interface IProgressProps {
  percent: number;
  color: "green" | "black" | "red" | "blue";
  className?: string;
  progressClassName?: string;
  size?: "small" | "medium" | "large";
}

export const Progress: React.FC<IProgressProps> = (props) => {
  const {
    percent,
    color,
    size = "small",
    className,
    progressClassName,
  } = props;

  return (
    <div
      className={twMerge(
        "h-1 w-full overflow-hidden rounded-full bg-base-light-grey",
        size === "medium" && "h-1.5",
        size === "large" && "h-2",
        className,
      )}
    >
      <div
        style={{ width: `${percent}%` }}
        className={twMerge(
          "h-full transition-all",
          color === "green" && "bg-base-green",
          color === "red" && "bg-base-red",
          color === "black" && "bg-base-black",
          color === "blue" && "bg-blue-dark",
          progressClassName,
        )}
      ></div>
    </div>
  );
};
